import { Spinner } from '@blueprintjs/core';
import React, { FunctionComponent } from 'react';
import ErrorMessage from 'uf/ui/base/ErrorMessage/ErrorMessage';
import { useIsLayerFavoritable } from 'uf/ui/layers/LayerListItem/hooks';
import { LayerColumns } from './LayerColumns';
import { LayerHeader } from './LayerHeader';
import Flex from 'uf/ui/base/Flex';
import { useGetLayerQuery } from 'uf-api-rtk/store/Api';
import { parseFullPath } from 'uf/base/dataset';
import { useSelector } from 'react-redux';
import { getActiveProjectId } from 'uf/app/selectors';
import { LayerId } from 'uf/layers';

interface OwnProps {
  layerId: LayerId;
  displayPanelView?: boolean;
  charLimit?: number;
}

const LayerMetadataSummary: FunctionComponent<OwnProps> = ({
  displayPanelView,
  charLimit,
  layerId,
}) => {
  const projectId = useSelector(getActiveProjectId);
  const {
    namespace,
    type: layerType,
    key,
  } = layerId ? parseFullPath(layerId) : { namespace: '', type: '', key: '' };
  const { data, isError, isFetching, isLoading, error } = useGetLayerQuery(
    {
      namespace,
      layerType,
      key,
    },
    { skip: !layerId },
  );
  const isLayerFavoritable = useIsLayerFavoritable(projectId, layerId);
  if (isFetching || isLoading) {
    return (
      <Flex justifyContent="center" style={{ minHeight: '20vh' }}>
        <Spinner className="tw-self-center" />
      </Flex>
    );
  }

  if (isError) {
    return <ErrorMessage error={error} />;
  }

  return (
    <Flex
      flexDirection="col"
      style={{
        padding: 24,
        maxHeight: displayPanelView
          ? // Source Tab
            'calc(100vh - 124px)'
          : // Layer Manager
            'calc(70vh - 30px)',
        overflowY: 'scroll',
        width: '100%',
      }}>
      {data && (
        <>
          <LayerHeader
            isLayerFavoritable={isLayerFavoritable}
            layerMetadata={data}
            displayPanelView={displayPanelView}
          />
          <LayerColumns
            charLimit={charLimit}
            layerMetadata={data}
            displayPanelView={displayPanelView}
          />
        </>
      )}
    </Flex>
  );
};

export default LayerMetadataSummary;
